module.exports = __webpack_public_path__ + "static/img/38.8b17d39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/38.jpg
// module id = OjTj
// module chunks = 1